import { api } from './api';

export async function GetTutoriails() {
  const { data } = await api.get('database/tutorial__c?strict=true&q=_id:%27tutorial_1%27');
  return data;
}